import $ from "jquery";
import SimpleBar from "simplebar";
import { debounce } from "../utils/debounce";

// https://codepen.io/wilburlikesmith/pen/xqpJxa
const $widget = $(".js-instafeed");
let mouseMovePadding = 60; // mousemove Padding
let responseSoftness = 50; // Mmusemove response softness
let width;
let scrollWidth;
let widthDiff; // widths difference ratio
let mX; // real mouse position
let mX2; // modified mouse position
let posX; // scroll position
let mmAA; // the mousemove available area
let mmAAr; // get available mousemove difference ratio
let intervalPositionHandlerId;

let $scrollElement;
if ($widget.length) {
  const simplebar = new SimpleBar($widget.find(".js-wrapper")[0]);
  $scrollElement = $(simplebar.getScrollElement());

  $(window).on("resize", debounce(horizontalSrollInit));
  horizontalSrollInit();
}

function horizontalSrollInit() {
  clearInterval(intervalPositionHandlerId);
  unbindEventHandlers();

  if (!$widget.length) return;

  width = $scrollElement.outerWidth();
  scrollWidth = $scrollElement[0].scrollWidth;
  widthDiff = scrollWidth / width - 1;
  mX = 0;
  mX2 = 0;
  posX = 0;
  mmAA = width - mouseMovePadding * 2;
  mmAAr = width / mmAA;

  bindEventHandlers();
}

function bindEventHandlers() {
  $scrollElement
    .on("mousemove", mouseMoveHandler)
    .on("mouseenter", scrollPositionHandler);
}

function unbindEventHandlers() {
  $scrollElement
    .off("mousemove", mouseMoveHandler)
    .off("mouseenter", scrollPositionHandler);
}

function mouseMoveHandler(e) {
  const parentOffset = $(this)
    .parent()
    .offset().left;
  mX = e.pageX - parentOffset - this.offsetLeft;
  mX2 = Math.min(Math.max(0, mX - mouseMovePadding), mmAA) * mmAAr;
}

function scrollPositionHandler() {
  intervalPositionHandlerId = setInterval(() => {
    posX += (mX2 - posX) / responseSoftness; // zeno's paradox equation "catching delay"
    $scrollElement.scrollLeft(posX * widthDiff);
  }, 10);
}
